var Handlebars = require("../../node_modules/.pnpm/handlebars@4.7.8_patch_hash=c5t5wnxp6mvabdrpn7wm4zt2zu/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div id=\"message_inline_image_tooltip\">\n    <strong>"
    + alias1(container.lambda(container.strict(depth0, "title", {"start":{"line":2,"column":15},"end":{"line":2,"column":20}} ), depth0))
    + "</strong>\n    <div class=\"tooltip-inner-content italic\">"
    + alias1(lookupProperty(helpers,"t").call(depth0 != null ? depth0 : (container.nullContext || {}),"Click to view or download.",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":3,"column":46},"end":{"line":3,"column":80}}}))
    + "</div>\n</div>\n";
},"useData":true});